<template>
  <validation-observer ref="observer" v-slot="{ invalid }">
    <v-card class="pb-4" outlined>
      <v-card-title class="py-1" :style="{ 'background-color': '#eeeeee' }">
        {{ $t('MSG0081') }}
      </v-card-title>
      <v-card-text class="py-1">
        <v-container class="form-sa-supplier px-2 py-2" fluid>
          <v-form :disabled="!canEditContents">
            <v-row>
              <v-col cols="2">
                <SelectSingleInput
                  v-model="form.productionCatCd"
                  :items="productionCatItems"
                  itemText="name"
                  itemValue="value"
                  :label="$t('ELE0221')"
                  required
                />
              </v-col>
              <v-col cols="2">
                <TextFieldInputWithDatePicker
                  :label="$t('ELE0223')"
                  v-model="form.issueDate"
                  disableFutureDate
                  required
                />
              </v-col>
              <v-col cols="3">
                <SectionInput
                  v-model="form.sectionCd"
                  :validOnly="canEditContents"
                  required
                  :disabled="hasGeneratedSaNo"
                />
              </v-col>
              <v-col cols="3">
                <ManufacturerInput
                  v-model="form.manufacturerCd"
                  :validOnly="canEditContents"
                  @change="onChangeManufacturer"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <SaReasonMultipleInput v-model="form.saReasonCds" :validOnly="canEditContents" required />
              </v-col>
              <v-col cols="8">
                <TextAreaInput
                  v-if="canEditContents"
                  :label="$t('ELE0292')"
                  v-model="form.reasonDtl"
                  :maxLength="1000"
                />
                <TextAreaRef v-else :label="$t('ELE0292')" :value="form.reasonDtl" />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card elevation="1" max-width="1200px" outlined>
                  <v-card-title class="py-0">
                    {{ $t('ELE0142') }}
                  </v-card-title>
                  <v-card-text class="py-4">
                    <v-row>
                      <v-col>
                        <PartCodeInput
                          v-if="isEpson && form.manufacturerCd == ''"
                          v-model="form.partCd"
                          :validOnly="canEditContents"
                          required
                          @change="onChangePartCd"
                        />
                        <SupplierPartInput
                          v-else
                          v-model="form.partCd"
                          :supplierCd="form.manufacturerCd"
                          isSearchByLoginCompany
                          :validOnly="canEditContents"
                          required
                          @change="onChangePartCd"
                        />
                      </v-col>
                      <v-col>
                        <TextFieldRef :label="$t('ELE0224')" :value="form.model" />
                      </v-col>
                      <v-col>
                        <TextFieldInput
                          v-if="canEditContents"
                          :label="$t('ELE0225')"
                          v-model="form.drawingRev"
                          rules="halfWidth"
                          :maxLength="20"
                        />
                        <TextFieldRef v-else :label="$t('ELE0225')" :value="form.drawingRev" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <TextFieldInput
                          v-if="canEditContents"
                          :label="$t('ELE0226')"
                          v-model="form.toolNoCav"
                          rules="halfWidth"
                          :maxLength="20"
                        />
                        <TextFieldRef v-else :label="$t('ELE0226')" :value="form.toolNoCav" />
                      </v-col>
                      <v-col> </v-col>
                      <v-col></v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card class="pb-2" elevation="1" max-width="1200px" outlined>
                  <v-card-title class="py-1">
                    {{ $t('ELE0252') }}
                    <v-spacer />
                    <BtnAdd @click="onAddLot" :disabled="!canEditContents" />
                  </v-card-title>
                  <v-card class="mx-2" outlined>
                    <v-data-table
                      :headers="headersLot"
                      :items="saLots"
                      dense
                      disable-pagination
                      hide-default-footer
                      mobile-breakpoint="0"
                    >
                      <template v-slot:[`item.action`]="{ item, index }">
                        <IconInquiry @click="onInquiryLot(item)" :disabled="!item.inspIndexNo" left />
                        <IconDelete :disabled="!canEditContents" @click="onDeleteLot(index)" right />
                      </template>
                      <template v-slot:[`item.lot`]="{ item, index }">
                        <TextFieldInput
                          :vid="'lot_' + index"
                          label=""
                          v-model="item.lot"
                          rules="halfWidth"
                          :maxLength="40"
                          required
                          @change="onChangeLot(index)"
                        />
                      </template>
                      <template v-slot:[`item.lotQty`]="{ item, index }">
                        <TextFieldInput
                          :vid="'lotQty_' + index"
                          label=""
                          v-model="item.lotQty"
                          right
                          rules="rangeNumber:1,9999999"
                          required
                        />
                      </template>
                      <template v-slot:[`item.remarks`]="{ item }">
                        <TextFieldInput label="" v-model="item.remarks" :maxLength="1000" />
                      </template>
                    </v-data-table>
                  </v-card>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
          <v-row>
            <v-col>
              <v-card elevation="1" max-width="1200px" outlined :disabled="form.partCd == ''">
                <v-tabs fixed-tabs v-model="inspClassTab">
                  <v-tab
                    class="ml-0"
                    :href="`#${enumInspClassCd.DIM}`"
                    :disabled="!canEditContents"
                    @click="onClickInspClassTab"
                  >
                    {{ $t('ELE0229') }}
                  </v-tab>
                  <v-tab :href="`#${enumInspClassCd.APP}`" :disabled="!canEditContents" @click="onClickInspClassTab">
                    {{ $t('ELE0211') }}
                  </v-tab>
                  <v-tab-item :value="`${enumInspClassCd.DIM}`">
                    <v-form :disabled="!canEditDimValue">
                      <v-card class="pb-2">
                        <v-card-title class="py-0 pb-1">
                          <v-spacer />
                          <BtnAdd @click="onAddDim" :disabled="!ifExtendCanEditContents" />
                        </v-card-title>
                        <v-card class="mx-2" outlined>
                          <v-data-table
                            :headers="headersDim"
                            :items="saDims"
                            dense
                            disable-pagination
                            hide-default-footer
                            mobile-breakpoint="0"
                          >
                            <template #header>
                              <thead>
                                <tr>
                                  <th colspan="2" class="v-data-table__divider"></th>
                                  <th colspan="3" class="v-data-table__divider">{{ $t('ELE0179') }}</th>
                                  <th colspan="3">{{ $t('ELE0180') }}</th>
                                </tr>
                              </thead>
                            </template>
                            <template v-slot:[`item.action`]="{ index }">
                              <IconDelete @click="onDeleteDim(index)" :disabled="!canEditContents" />
                            </template>

                            <template v-slot:[`item.inspCharacDtlNo`]="{ item, index }">
                              <InspCharacDtlInput
                                :vid="'charac_' + index"
                                label=""
                                v-model="item.inspCharacDtlNo"
                                :partCd="form.partCd"
                                :inspCharacRev="form.inspCharacRev"
                                :exceptCdList="selectedCharacs"
                                required
                                :disabled="!ifExtendCanEditContents"
                                @selectedItem="onSelectedCharac($event, index)"
                              />
                            </template>
                            <template v-slot:[`item.saStandard`]="{ item, index }">
                              <TextFieldInput
                                v-if="item.standard !== null"
                                :vid="'saStandard_' + index"
                                :class="getCellClass(item.standard, item.saStandard)"
                                label=""
                                v-model="item.saStandard"
                                right
                                rules="inspCharacVal"
                                required
                                :disabled="!canEditDimValue"
                              />
                            </template>
                            <template v-slot:[`item.saUpper`]="{ item, index }">
                              <TextFieldInput
                                v-if="item.upper !== null"
                                :vid="'saUpper_' + index"
                                :class="getCellClass(item.upper, item.saUpper)"
                                label=""
                                v-model="item.saUpper"
                                right
                                :rules="`inspCharacVal|saInspCharacVal:${item.saUpper},${item.saLower}|saExtendCharacUpperVal:${item.inspCharacCd},${item.inspCharacPoint}`"
                                required
                                :disabled="!canEditDimValue"
                              />
                            </template>
                            <template v-slot:[`item.saLower`]="{ item, index }">
                              <TextFieldInput
                                v-if="item.lower !== null"
                                :vid="'saLower_' + index"
                                :class="getCellClass(item.lower, item.saLower)"
                                label=""
                                v-model="item.saLower"
                                right
                                :rules="`inspCharacVal|saInspCharacVal:${item.saUpper},${item.saLower}|saExtendCharacLowerVal:${item.inspCharacCd},${item.inspCharacPoint}`"
                                required
                                :disabled="!canEditDimValue"
                              />
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-card>
                    </v-form>
                  </v-tab-item>
                  <v-tab-item :value="`${enumInspClassCd.APP}`">
                    <v-form :disabled="!canEditContents">
                      <v-card class="pb-2" max-width="1000px" flat>
                        <v-card-title class="pt-0 pb-1">
                          <v-spacer />
                          <BtnAdd @click="onAddApp" :disabled="!ifExtendCanEditContents" />
                        </v-card-title>
                        <v-card class="mx-2" outlined>
                          <v-data-table
                            :headers="headersApp"
                            :items="saApps"
                            dense
                            disable-pagination
                            hide-default-footer
                            mobile-breakpoint="0"
                          >
                            <template v-slot:[`item.action`]="{ index }">
                              <IconDelete @click="onDeleteApp(index)" :disabled="!canEditContents" />
                            </template>
                            <template v-slot:[`item.fileTitle`]="{ item, index }">
                              <TextFieldInput
                                :vid="'fileTitle_' + index"
                                label=""
                                v-model="item.fileTitle"
                                :maxLength="40"
                                required
                                :disabled="!canEditContents"
                              />
                            </template>
                            <template v-slot:[`item.filePath`]="{ item, index }">
                              <FileInput
                                :vid="'filePath_' + index"
                                label=""
                                v-model="item.file"
                                :filePath="item.filePath"
                                required
                                :disabled="!canEditContents"
                              />
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-card>
                    </v-form>
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="pt-4 pb-2">
            <v-col cols="4">
              <v-form :disabled="!canEditAttach">
                <v-card class="pb-2" elevation="1" max-width="700px" outlined>
                  <v-card-title class="py-1">
                    {{ $t('ELE0232') }}
                    <v-spacer />
                    <BtnAdd :disabled="!canEditAttach" @click="onAddAttach" />
                  </v-card-title>
                  <v-card class="mx-2" outlined>
                    <v-data-table
                      :headers="headersAttach"
                      :items="attachFiles"
                      dense
                      disable-pagination
                      hide-default-footer
                      mobile-breakpoint="0"
                    >
                      <template v-slot:[`item.action`]="{ item, index }">
                        <IconDelete :disabled="!canDeleteAttach(item)" @click="onDeleteAttach(index)" />
                      </template>
                      <template v-slot:[`item.filePath`]="{ item, index }">
                        <FileInput
                          :vid="'filePath_' + index"
                          label=""
                          v-model="item.file"
                          :filePath="item.filePath"
                          required
                        />
                      </template>
                    </v-data-table>
                  </v-card>
                </v-card>
              </v-form>
            </v-col>
            <v-col cols="8">
              <TextAreaInput
                v-if="canEditNextAction"
                :label="$t('ELE0231')"
                v-model="form.nextAction"
                :maxLength="1000"
                :disabled="!canEditNextAction"
              />
              <TextAreaRef v-else :label="$t('ELE0231')" :value="form.nextAction" />
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col cols="6">
              <v-form>
                <v-card class="pb-2" elevation="1" max-width="1200px" outlined>
                  <v-card-title class="py-1">
                    {{ $t('ELE0546') }}
                    <v-spacer />
                    <BtnAdd :disabled="!canEditLink" @click="onClickAddLink" />
                  </v-card-title>
                  <v-card class="mx-2" outlined>
                    <v-data-table
                      :headers="headersLink"
                      :items="resolvedLinks"
                      dense
                      disable-pagination
                      hide-default-footer
                      mobile-breakpoint="0"
                    >
                      <template v-slot:[`item.action`]="{ item, index }">
                        <IconDelete :disabled="!canDeleteLink(item)" @click="onDeleteLink(index)" />
                      </template>
                      <template v-slot:[`item.link`]="{ item }">
                        <!-- 正規化されたリンクのみリンク表示  -->
                        <a v-if="item.href" :href="item.href" target="_blank" rel="noopener noreferrer">
                          {{ item.title }}
                        </a>
                        <div v-else>{{ item.title }}</div>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-card>
              </v-form>
            </v-col>
          </v-row>
          <v-form :disabled="!(canEditRoute || canEditCmsRoute)">
            <v-row>
              <v-col>
                <v-card elevation="1" max-width="1200px" outlined>
                  <SaRequestRouteForm
                    :companyCd="form.requestCompanyCd"
                    :companyCatCd="form.requestCompanyCatCd"
                    :currentRouteNo="form.currentRouteNo"
                    :currentRouteDtlNo="form.currentRouteDtlNo"
                    :routeNo="form.supplierRoute.routeNo"
                    :checkers.sync="form.supplierRoute.checkers"
                    :disabled="!canEditRoute"
                    outlined
                  />
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="isCmsRoute">
              <v-col>
                <v-card elevation="1" max-width="1200px" outlined>
                  <SaRequestRouteForm
                    :routeTitle="$t('ELE0508')"
                    :companyCd="form.requestCompanyCd"
                    :companyCatCd="form.requestCompanyCatCd"
                    :currentRouteNo="form.currentRouteNo"
                    :currentRouteDtlNo="form.currentRouteDtlNo"
                    :routeNo="form.cmsSupplierRoute.routeNo"
                    :checkers.sync="form.cmsSupplierRoute.checkers"
                    :disabled="!canEditCmsRoute"
                    outlined
                  />
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <UserInput
                  :label="$t('ELE0238')"
                  v-model="form.accepterCd"
                  :companyCat="enumCompanyCatCd.EPSON"
                  :roleCdList="[enumRole.SA_CHECK, enumRole.SA_APPROVE]"
                  :validOnly="canEditRoute || canEditCmsRoute"
                  required
                />
              </v-col>
              <v-col cols="4">
                <TextFieldInputWithDatePicker
                  :label="$t('ELE0517')"
                  v-model="form.responseUntil"
                  disablePastDate
                  clearable
                  :disabled="!canEditRoute"
                />
              </v-col>
            </v-row>
          </v-form>
          <v-row v-if="canEditRoute || canEditCmsRoute" class="py-2">
            <v-col>
              <v-container v-if="!isCmsRoute" fluid class="px-0 d-flex justify-end">
                <Btn
                  class="mr-8"
                  :label="$t('ELE0036')"
                  :disabled="invalid || !canDelete"
                  isCheckRole
                  @click="onClickDelete"
                />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0247')"
                  :disabled="invalid || !canTempSave"
                  isCheckRole
                  @click="onClickTempSave"
                />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0248')"
                  :disabled="invalid || !canRequest"
                  isCheckRole
                  @click="onClickRequest"
                />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0215')"
                  :disabled="invalid || !canApprove"
                  isCheckRole
                  @click="onClickApprove"
                />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0249')"
                  :disabled="invalid || !canDeny"
                  isCheckRole
                  @click="onClickDeny"
                />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0250')"
                  :disabled="invalid || !canReturnToRequest"
                  isCheckRole
                  @click="onClickReturnToRequest"
                />
              </v-container>
              <v-container v-else fluid class="px-0 d-flex justify-end">
                <Btn class="mr-8" :label="$t('ELE0036')" disabled />
                <Btn class="mx-4" :label="$t('ELE0247')" disabled />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0248')"
                  :disabled="invalid || !canRequestCms"
                  isCheckRole
                  @click="onClickRequestCms"
                />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0215')"
                  :disabled="invalid || !canApproveCms"
                  isCheckRole
                  @click="onClickApproveCms"
                />
                <Btn class="mx-4" :label="$t('ELE0249')" disabled />
                <Btn
                  class="mx-4"
                  :label="$t('ELE0250')"
                  :disabled="invalid || !canReturnToRequestCms"
                  isCheckRole
                  @click="onClickReturnToRequestCms"
                />
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <LinkAttachmentDialog :dialog.sync="displayAddLinkDialog" @set="onAddLink" />

    <DelConfirmDialog
      :dialog="delConfirmDialog"
      :confirmWord="$t('MSG0013')"
      :btnLabel="$t('ELE0036')"
      @cancel="delConfirmDialog = false"
      @proceed="onProceedDelete"
    />
    <InspClassConfirmDialog
      :dialog="inspClassConfirmDialog"
      :confirmWord="$t('MSG0076')"
      :btnLabel="$t('ELE0264')"
      @cancel="cancelChangeInspClassTab"
      @proceed="changeInspClassTab"
    />
    <UserConfirmDialog
      :dialog="userConfirmDialog"
      :confirmWord="$t('MSG0090')"
      :btnLabel="$t('ELE0019')"
      @cancel="userConfirmDialog = false"
      @proceed="onProceedSave"
    />
    <OqcResultDialog
      v-if="oqcResultDialog"
      :dialog.sync="oqcResultDialog"
      :inspIndexNo="oqcResult.inspIndexNo"
      :inspCompanyCd="form.manufacturerCd"
      :lotNo="oqcResult.lotNo"
      :partCd="form.partCd"
      :partName="form.partName"
      :inspCat1="oqcResult.inspCat1"
      :inspCat2="oqcResult.inspCat2"
      :lotDate="oqcResult.lotDate"
      inspDataViewOnly
    />
  </validation-observer>
</template>

<script>
import { mapGetters } from 'vuex'
import { ValidationObserver, extend } from 'vee-validate'
import {
  InspClassCd,
  SaProductionCatCd,
  Role,
  SaWfCheckedCat,
  SaApprovalStatusCd,
  S3Root,
  CompanyCatCd,
  OqcIqcCd,
  CmsApprovalStatusCd,
  SystemParameterKey,
  SaFileCatCd,
  SaLinkCatCd,
} from '@/enum'
import BigNumber from 'bignumber.js'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import StringUtils from '@/mixin/string-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtil from '@/mixin/date-utils.js'
import { Storage } from '@/plugins/storage'

import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import TextAreaInput from '@/components/atoms/base/text-field/TextAreaInput'
import TextAreaRef from '@/components/atoms/base/text-field/TextAreaRef'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker'
import Btn from '@/components/atoms/base/button/Btn'
import BtnAdd from '@/components/atoms/button/BtnAdd'
import BtnDelete from '@/components/atoms/button/BtnDelete'
import IconDelete from '@/components/atoms/icon/IconDelete.vue'
import IconInquiry from '@/components/atoms/icon/IconInquiry'
import FileInput from '@/components/atoms/file/FileInput'
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'

import UserInput from '@/components/atoms/select/UserInput'
import PartCodeInput from '@/components/atoms/select/PartCodeInput'
import SupplierPartInput from '@/components/atoms/select/SupplierPartInput'
import SaReasonMultipleInput from '@/components/atoms/select/SaReasonMultipleInput'
import InspCharacDtlInput from '@/components/atoms/select/InspCharacDtlInput'

import SaRequestRouteForm from '@/components/organisms/terminal/form/SaRequestRouteForm'
import DelConfirmDialog from '@/components/organisms/common/dialog/ConfirmDialog'
import InspClassConfirmDialog from '@/components/organisms/common/dialog/ConfirmDialog'
import LinkAttachmentDialog from '@/components/organisms/terminal/dialog/LinkAttachmentDialog'
import UserConfirmDialog from '@/components/organisms/common/dialog/ConfirmDialog'
import SectionInput from '@/components/atoms/select/SectionInput'
import OqcResultDialog from '@/components/organisms/terminal/dialog/ApprovalInspDataListDialog'
import ManufacturerInput from '@/components/atoms/select/ManufacturerInput'

/** 処理モード */
export const SaveMode = {
  TEMP_SAVE: 'TEMP_SAVE',
  REQUEST: 'REQUEST',
  APPROVE: 'APPROVE',
  DENY: 'DENY',
  RETURN: 'RETURN',
  CMS_REQUEST: 'CMS_REQUEST',
  CMS_APPROVE: 'CMS_APPROVE',
  CMS_RETURN: 'CMS_RETURN',
}

export default {
  name: 'SaRequestSupplierForm',

  mixins: [APIUtils, Message, StringUtils, Loading, DateUtil],

  components: {
    ValidationObserver,
    TextFieldInput,
    TextFieldRef,
    TextAreaInput,
    TextAreaRef,
    TextFieldInputWithDatePicker,
    Btn,
    BtnAdd,
    BtnDelete,
    IconDelete,
    IconInquiry,
    FileInput,
    SelectSingleInput,
    UserInput,
    PartCodeInput,
    SupplierPartInput,
    SaReasonMultipleInput,
    InspCharacDtlInput,
    SaRequestRouteForm,
    DelConfirmDialog,
    InspClassConfirmDialog,
    LinkAttachmentDialog,
    UserConfirmDialog,
    SectionInput,
    OqcResultDialog,
    ManufacturerInput,
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
    isExtend: {
      type: Boolean,
      default: false,
      required: false,
    },
    isCmsRoute: {
      type: Boolean,
      default: false,
      required: false,
    },
    canEditEpson: {
      type: Boolean,
      required: true,
    },
    canApproveEpson: {
      type: Boolean,
      required: true,
    },
    canReturnEpson: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      canEditSaDim: false,
      inspClassTab: '',
      headersLot: [
        { text: '', value: 'action', align: 'center', divider: true, sortable: false, width: '50' },
        {
          text: this.$t('ELE0253'),
          value: 'lot',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
        },
        {
          text: this.$t('ELE0174'),
          value: 'lotQty',
          align: 'right',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
        },
        { text: this.$t('ELE0054'), value: 'remarks', sortable: false, cellClass: 'py-1' },
      ],
      headersDim: [
        { text: '', value: 'action', align: 'center', divider: true, sortable: false, width: '50' },
        {
          text: this.$t('ELE0091'),
          value: 'inspCharacDtlNo',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
          width: '300',
        },
        {
          text: this.$t('ELE0095'),
          value: 'standard',
          divider: true,
          sortable: false,
          align: 'end',
          cellClass: 'py-1',
        },
        { text: this.$t('ELE0096'), value: 'upper', divider: true, sortable: false, align: 'end', cellClass: 'py-1' },
        { text: this.$t('ELE0097'), value: 'lower', divider: true, sortable: false, align: 'end', cellClass: 'py-1' },
        {
          text: this.$t('ELE0095'),
          value: 'saStandard',
          divider: true,
          sortable: false,
          align: 'end',
          cellClass: 'py-1',
        },
        { text: this.$t('ELE0096'), value: 'saUpper', divider: true, sortable: false, align: 'end', cellClass: 'py-1' },
        { text: this.$t('ELE0097'), value: 'saLower', sortable: false, align: 'end', cellClass: 'py-1' },
      ],
      headersApp: [
        { text: '', value: 'action', align: 'center', divider: true, sortable: false, width: '50' },
        { text: this.$t('ELE0033'), value: 'fileTitle', divider: true, sortable: false, cellClass: 'py-1' },
        { text: this.$t('ELE0230'), value: 'filePath', sortable: false, cellClass: 'py-1' },
      ],
      headersAttach: [
        { text: '', value: 'action', align: 'center', divider: true, sortable: false, width: '50' },
        { text: this.$t('ELE0035'), value: 'filePath', sortable: false, cellClass: 'py-1' },
      ],
      headersLink: [
        { text: '', value: 'action', align: 'center', divider: true, sortable: false, width: '50' },
        { text: this.$t('ELE0546'), value: 'link', sortable: false, cellClass: 'py-1' },
      ],
      displayAddLinkDialog: false,
      delConfirmDialog: false,
      inspClassConfirmDialog: false,
      userConfirmDialog: false,
      oqcResultDialog: false,
      oqcResult: {},
      mode: '',
      settings: [
        {
          mode: SaveMode.TEMP_SAVE,
          url: '/sa/supplier/tempSave',
          isValidateChecker: false,
          isUploadAppFile: true,
          isUploadAttachFile: true,
        },
        {
          mode: SaveMode.REQUEST,
          url: '/sa/supplier/request',
          isValidateChecker: true,
          isUploadAppFile: true,
          isUploadAttachFile: true,
        },
        {
          mode: SaveMode.APPROVE,
          url: '/sa/supplier/approve',
          isValidateChecker: true,
          isUploadAppFile: false,
          isUploadAttachFile: true,
        },
        {
          mode: SaveMode.DENY,
          url: '/sa/supplier/deny',
          isValidateChecker: true,
          isUploadAppFile: false,
          isUploadAttachFile: true,
        },
        {
          mode: SaveMode.RETURN,
          url: '/sa/supplier/return',
          isValidateChecker: false,
          isUploadAppFile: false,
          isUploadAttachFile: false,
        },
        {
          mode: SaveMode.CMS_REQUEST,
          url: '/sa/supplier/cms/request',
          isValidateChecker: true,
          isUploadAppFile: true,
          isUploadAttachFile: true,
        },
        {
          mode: SaveMode.CMS_APPROVE,
          url: '/sa/supplier/cms/approve',
          isValidateChecker: true,
          isUploadAppFile: false,
          isUploadAttachFile: true,
        },
        {
          mode: SaveMode.CMS_RETURN,
          url: '/sa/supplier/cms/return',
          isValidateChecker: false,
          isUploadAppFile: false,
          isUploadAttachFile: false,
        },
      ],
    }
  },

  computed: {
    ...mapGetters(['isEpson']),

    enumInspClassCd: () => InspClassCd,
    enumCompanyCatCd: () => CompanyCatCd,
    enumRole: () => Role,
    loginUserCd: {
      get() {
        return this.$store.getters.userCd
      },
    },
    setting: {
      get() {
        return this.settings.find((el) => el.mode === this.mode)
      },
    },
    canEditCompany: {
      get() {
        let result = false
        if (
          this.form.requestCompanyCatCd == CompanyCatCd.SUPPLIER &&
          this.form.requestCompanyCd == this.$store.getters.companyCd
        ) {
          result = true
        } else if (this.form.requestCompanyCatCd == CompanyCatCd.EPSON && this.isEpson) {
          result = true
        }
        return result
      },
    },
    canEditContents: {
      get() {
        let result = false

        if (!this.canEditCompany) {
          result = false
        } else if (!this.form.statusCd || this.form.statusCd == SaApprovalStatusCd.TEMP_SAVE) {
          result = true
        }

        return result
      },
    },
    canEditCmsContents: {
      get() {
        let result = false

        if (!this.canEditCompany) {
          result = false
        } else if (this.form.cmsStatusCd && this.form.cmsStatusCd == CmsApprovalStatusCd.TEMP_SAVE) {
          result = true
        }

        return result
      },
    },
    canEditDimValue: {
      get() {
        // システムパラメータ―のCAN_EDIT_SA_DIMがTrueかつ、Supplier Approvedの場合のみDIM編集可能
        return (
          this.canEditContents ||
          (this.canEditSaDim && this.canEditEpson && this.form.statusCd == SaApprovalStatusCd.SUPPLIER_APPROVED)
        )
      },
    },
    ifExtendCanEditContents: {
      get() {
        let result = this.canEditContents
        if (this.isExtend) {
          result = false
        }
        return result
      },
    },
    canTempSave: {
      get() {
        return this.canEditContents
      },
    },
    canRequest: {
      get() {
        return this.canEditContents
      },
    },
    canRequestCms: {
      get() {
        return this.canEditCmsContents
      },
    },
    canDelete: {
      get() {
        return this.canTempSave && this.form.statusCd != ''
      },
    },
    canEditRoute: {
      get() {
        return this.canRequest || this.canApprove || this.canReturnToRequest
      },
    },
    canEditCmsRoute: {
      get() {
        return this.canRequestCms || this.canApproveCms || this.canReturnToRequestCms
      },
    },
    canApprove: {
      get() {
        let result = false

        if (this.canEditCompany && this.form.statusCd == SaApprovalStatusCd.SUPPLIER_APPLYING && this.hasEditRole) {
          result = true
        }
        return result
      },
    },
    canApproveCms: {
      get() {
        let result = false

        if (this.canEditCompany && this.form.cmsStatusCd == CmsApprovalStatusCd.SUPPLIER_APPLYING && this.hasEditRole) {
          result = true
        }
        return result
      },
    },
    hasEditRole: {
      get() {
        let result = false
        const currentCheckedCat = this.form.currentCheckedCat
        const hasCheck = this.$store.getters.hasRole(Role.SA_CHECK)
        const hasApprove = this.$store.getters.hasRole(Role.SA_APPROVE)

        if (currentCheckedCat == SaWfCheckedCat.CHECK && hasCheck) {
          result = true
        } else if (currentCheckedCat == SaWfCheckedCat.APPROVE && hasApprove) {
          result = true
        } else {
          result = false
        }
        return result
      },
    },
    canDeny: {
      get() {
        return this.canApprove
      },
    },
    canEditLink: {
      get() {
        let result = false
        // prepareRouteで申請者が編集できる条件
        if ((this.canEditCompany && this.canEditContents) || (this.canEditCompany && this.canEditCmsContents)) {
          result = true
        }
        // prepareRouteで承認者が編集できる条件
        else if (
          (this.canEditCompany && this.canReturnToRequest && this.canApprove) ||
          (this.canEditCompany && this.canReturnToRequestCms && this.canApproveCms)
        ) {
          result = true
        }
        // EPSONユーザーが編集できる条件
        else if (this.canEditEpson && this.canReturnEpson && this.canApproveEpson) {
          result = true
        } else {
          result = false
        }
        return result
      },
    },
    canReturnToRequest: {
      get() {
        const hasCheck = this.$store.getters.hasRole(Role.SA_CHECK)
        const hasApprove = this.$store.getters.hasRole(Role.SA_APPROVE)
        return (
          this.form.statusCd == SaApprovalStatusCd.SUPPLIER_APPLYING && this.canEditCompany && (hasCheck || hasApprove)
        )
      },
    },
    canReturnToRequestCms: {
      get() {
        const hasCheck = this.$store.getters.hasRole(Role.SA_CHECK)
        const hasApprove = this.$store.getters.hasRole(Role.SA_APPROVE)
        return (
          this.form.cmsStatusCd == CmsApprovalStatusCd.SUPPLIER_APPLYING &&
          this.canEditCompany &&
          (hasCheck || hasApprove)
        )
      },
    },
    canEditNextAction: {
      get() {
        return (
          this.canEditContents ||
          this.canReturnToRequest ||
          this.canEditEpson ||
          (this.canEditEpson && this.canEditCmsContents) ||
          this.canEditCmsRoute
        )
      },
    },
    canEditAttach: {
      get() {
        return this.canEditRoute || this.canEditCmsRoute
      },
    },
    saLots: {
      get() {
        return this.form.saLots
      },
    },
    saDims: {
      get() {
        return this.form.saDims
      },
    },
    relatedSaDims: {
      get() {
        return this.form.relatedSaDims
      },
    },
    saApps: {
      get() {
        return this.form.saApps
      },
    },
    attachFiles: {
      get() {
        return this.form.attachFiles
      },
    },
    relatedLinks: {
      get() {
        return this.form.relatedLinks
      },
    },
    productionCatItems: {
      get() {
        // プルダウン選択肢をenumから生成
        return Object.values(SaProductionCatCd).map((item) => {
          return { name: item + ' : ' + this.$t(`SaProductionCatCd.${item}`), value: item }
        })
      },
    },
    resolvedLinks() {
      // relatedLinksを表示するためのComputed
      return this.relatedLinks.map((it) => {
        //linkの正規化
        const href = this.normalizeUrl(it.link)
        return { ...it, href }
      })
    },
    selectedCharacs: {
      // 選択済みの検査特性リスト
      get() {
        let items = []
        for (let idx = 0; idx < this.form.saDims.length; idx++) {
          const dim = this.form.saDims[idx]
          items.push({ inspCharacDtlNo: dim.inspCharacDtlNo })
        }
        return items
      },
    },
    isFinalJudgeUser: {
      get() {
        // 最終判定者が操作しているか
        let finalRouteDtl = null
        finalRouteDtl = this.form.cmsSupplierRoute.checkers.slice(-1)[0] // 最終ルート
        return (
          finalRouteDtl.routeNo == this.form.currentRouteNo && finalRouteDtl.routeDtlNo == this.form.currentRouteDtlNo
        )
      },
    },
    hasGeneratedSaNo: {
      get() {
        let result = false
        if (this.form.saNo) {
          result = true
        }
        return result
      },
    },
  },

  methods: {
    async setParameter() {
      try {
        const element = await API.get(`/master/systemParameter/${SystemParameterKey.CAN_EDIT_SA_DIM}`)
        this.canEditSaDim = element.value.toLowerCase() === 'true'
      } catch (error) {
        if (error.response.status != 404) {
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0348') })))
        }
      }
    },
    getCellClass(value, saValue) {
      let result = ''
      if (value != saValue) {
        result = result + ' diff-text-field'
      }
      return result
    },
    onClickAddLink() {
      this.displayAddLinkDialog = true
    },
    onAddLink(linkDetail) {
      if (this.isCmsRoute) {
        linkDetail.linkCatCd = SaLinkCatCd.CMS_SA
      } else {
        linkDetail.linkCatCd = SaLinkCatCd.COMMON_SA
      }
      this.relatedLinks.push(linkDetail)
    },
    async onChangePartCd() {
      if (this.form.partCd) {
        try {
          this.startLoading()
          await this.getPartInfo()
          await this.getInspCharac()
        } finally {
          this.form.saDims = []
          this.form.saApps = []
          for (const item of this.saLots) {
            item.inspIndexNo = ''
          }
          this.stopLoading()
        }
      }
    },
    async getPartInfo() {
      try {
        const params = {
          isLatest: true,
        }
        const element = await API.get(`/master/parts/${this.form.partCd}`, params)
        this.form.model = element.model
        this.form.partName = element.partName
      } catch (error) {
        this.form.model = ''
        this.form.partName = ''
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0059') })))
      }
    },
    async getInspCharac() {
      try {
        this.form.inspCharacRev = await API.get('/master/inspCharacHdrs/' + this.form.partCd + '/getRev')
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0091') })))
      }
    },
    onSelectedCharac(charac, index) {
      if (charac) {
        this.form.saDims[index].inspCharacCd = charac.inspCharacCd
        this.form.saDims[index].inspCharacPoint = charac.inspCharacPoint
        this.form.saDims[index].standard = charac.standard
        this.form.saDims[index].upper = charac.upper
        this.form.saDims[index].lower = charac.lower
      } else {
        this.form.saDims[index].inspCharacCd = ''
        this.form.saDims[index].inspCharacPoint = ''
        this.form.saDims[index].standard = null
        this.form.saDims[index].upper = null
        this.form.saDims[index].lower = null
      }

      this.form.saDims[index].saStandard = charac.standard
      this.form.saDims[index].saUpper = null
      this.form.saDims[index].saLower = null
    },
    onAddLot() {
      const item = {
        lot: '',
        lotQty: null,
        remarks: '',
        inspIndexNo: '',
      }
      this.saLots.push(item)
    },
    onDeleteLot(index) {
      this.saLots.splice(index, 1)
    },
    async onInquiryLot(item) {
      // SA申請後にOQC検査インデックスが物理削除された場合
      // 検査インデックス存在エラーメッセージを出して、承認ダイアログを開かない
      try {
        this.startLoading()
        const element = await API.get(`/inspIndex/inspIndexes/${item.inspIndexNo}`)
        this.oqcResult = {
          inspTimingCd: OqcIqcCd.OQC,
          inspIndexNo: item.inspIndexNo,
          lotNo: item.lot,
          inspCat1: element.inspCat1,
          inspCat2: element.inspCat2,
          lotDate: this.toLocalDate(element.inspCreateDatetime),
        }
        this.oqcResultDialog = true
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
      } finally {
        this.stopLoading()
      }
    },
    onAddDim() {
      const item = {
        inspCharacDtlNo: null,
        inspCharacCd: '',
        inspCharacPoint: '',
        standard: null,
        upper: null,
        lower: null,
        saStandard: null,
        saUpper: null,
        saLower: null,
      }
      this.saDims.push(item)
    },
    onDeleteDim(index) {
      this.saDims.splice(index, 1)
    },
    onAddApp() {
      const item = {
        fileTitle: '',
        filePath: '',
        file: null,
      }
      this.saApps.push(item)
    },
    onDeleteApp(index) {
      this.saApps.splice(index, 1)
    },
    onAddAttach() {
      let item = {
        filePath: '',
        file: null,
      }
      if (this.isCmsRoute) {
        item.fileCatCd = SaFileCatCd.CMS_SA
      } else {
        item.fileCatCd = SaFileCatCd.COMMON_SA
      }
      this.attachFiles.push(item)
    },
    onDeleteAttach(index) {
      this.attachFiles.splice(index, 1)
    },
    onDeleteLink(index) {
      this.relatedLinks.splice(index, 1)
    },
    onClickInspClassTab() {
      if (this.saDims.length > 0 || this.saApps.length > 0) {
        this.inspClassConfirmDialog = true
      }
    },
    changeInspClassTab() {
      this.inspClassConfirmDialog = false

      if (this.inspClassTab == InspClassCd.DIM) {
        this.saApps.splice(0, this.saApps.length)
      } else {
        this.saDims.splice(0, this.saDims.length)
      }
    },
    cancelChangeInspClassTab() {
      this.inspClassConfirmDialog = false

      if (this.inspClassTab == InspClassCd.DIM) {
        this.inspClassTab = InspClassCd.APP
      } else {
        this.inspClassTab = InspClassCd.DIM
      }
    },
    async onClickTempSave() {
      // 一時保存
      this.mode = SaveMode.TEMP_SAVE
      this.form.requesterCd = this.loginUserCd
      await this._save()
    },
    async onClickRequest() {
      // 申請
      this.mode = SaveMode.REQUEST
      this.form.requesterCd = this.loginUserCd
      await this._save()
    },
    async onClickRequestCms() {
      // 申請
      this.mode = SaveMode.CMS_REQUEST
      this.form.requesterCd = this.loginUserCd
      await this._save()
    },
    async onClickApprove() {
      // 承認
      this.mode = SaveMode.APPROVE
      await this._save()
    },
    async onClickApproveCms() {
      // 承認
      this.mode = SaveMode.CMS_APPROVE
      if (this.isFinalJudgeUser && !this.cmsAttachmentFileExists()) {
        this.setErrorMessage(this.$t('MSG0157'))
        return
      }
      await this._save()
    },
    async onClickDeny() {
      // 否認
      this.mode = SaveMode.DENY
      await this._save()
    },
    async onClickReturnToRequest() {
      // 申請者へ戻す
      this.mode = SaveMode.RETURN
      await this._save()
    },
    async onClickReturnToRequestCms() {
      // 申請者へ戻す
      this.mode = SaveMode.CMS_RETURN
      await this._save()
    },
    onClickDelete() {
      // 削除
      this.delConfirmDialog = true
    },
    async onProceedDelete() {
      // 削除
      try {
        this.delConfirmDialog = false

        this.startLoading()

        const body = {
          saNo: this.form.saNo,
          wfNo: this.form.wfNo,
          wfVersionNo: this.form.wfVersionNo,
        }

        await API.post('/sa/supplier/delete', body)
        this.setSuccessMessage(this.$t('MSG0014'))
        this.resetForm()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0004', { p0: this.form.saNo })))
      } finally {
        this.stopLoading()
      }
    },
    async onProceedSave() {
      // 保存を進める
      this.userConfirmDialog = false
      let checker = this.getCurrentChecker()
      checker.checkerCd = this.loginUserCd
      await this._save()
    },
    async onChangeLot(index) {
      try {
        this.startLoading()
        const saLot = this.saLots[index]
        saLot.inspIndexNo = null
        if (saLot.lot == '' || this.form.manufacturerCd == '') return

        const body = {
          lotNo: saLot.lot,
          partCd: this.form.partCd,
          manufacturerCd: this.form.manufacturerCd,
          inspTimingCd: OqcIqcCd.OQC,
        }

        const elements = await API.get('/inspIndex/inspIndexes/logicalKey', body)
        if (elements.length) {
          saLot.inspIndexNo = elements.slice(-1)[0].inspIndexNo
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
      } finally {
        this.stopLoading()
      }
    },
    async _save() {
      // 保存
      try {
        this.startLoading()

        if (!(await this.validate())) {
          return
        }

        if (!this.hasGeneratedSaNo) {
          // S3のファイルパスにSA Noを付けたいので事前に採番
          this.form.saNo = await API.post('/sa/generate/saNo', { sectionCd: this.form.sectionCd })
        }

        if (this.setting.isUploadAppFile) {
          await this.uploadAppFile()
        }

        if (this.setting.isUploadAttachFile) {
          await this.uploadAttachFile()
        }

        const body = {
          saNo: this.form.saNo,
          wfNo: this.form.wfNo,
          wfVersionNo: this.form.wfVersionNo,
          currentRouteNo: this.form.currentRouteNo,
          currentRouteDtlNo: this.form.currentRouteDtlNo,
          requestCompanyCd: this.form.requestCompanyCd,
          requesterCd: this.form.requesterCd,
          sectionCd: this.form.sectionCd,
          accepterCd: this.form.accepterCd,
          inspClassCd: this.inspClassTab,
          productionCatCd: this.form.productionCatCd,
          issueDate: this.form.issueDate,
          reasonDtl: this.form.reasonDtl,
          partCd: this.form.partCd,
          inspCharacRev: this.form.inspCharacRev,
          drawingRev: this.form.drawingRev,
          toolNoCav: this.form.toolNoCav,
          nextAction: this.form.nextAction,
          saReasonCds: this.form.saReasonCds,
          saLots: this.saLots,
          saDims: this.saDims,
          saApps: this.saApps,
          attachFiles: this.attachFiles,
          // WAFエラー回避のためLinkをエンコードしてPost
          relatedLinks: this.relatedLinks.map((item) => ({
            ...item,
            link: this.toBase64(item.link),
          })),
          routeNo: this.form.supplierRoute.routeNo,
          checkers: this.form.supplierRoute.checkers,
          orgSaNo: this.form.orgSaNo,
          extensionSaNo: this.form.extensionSaNo,
          extensionTime: this.form.extensionTime,
          responseUntil: this.form.responseUntil,
          cmsSupplierRoute: this.form.cmsSupplierRoute,
          manufacturerCd: this.form.manufacturerCd,
          requestComment: this.getCurrentChecker().remarks,
          cmsRequestComment: this.getCmsCurrentChecker()?.remarks,
        }
        await API.post(this.setting.url, body)
        this.setSuccessMessage(this.$t('MSG0011', { p0: this.form.saNo }))
        this.resetForm()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.form.saNo })))
      } finally {
        this.stopLoading()
      }
    },

    async validate() {
      // 入力チェック
      if (!(await this.$refs.observer.validate())) {
        return false
      }

      if (this.inspClassTab == InspClassCd.DIM) {
        if (this.saDims.length == 0) {
          this.setErrorMessage(this.$t('MSG0092'))
          return false
        }
      } else {
        if (this.saApps.length == 0) {
          this.setErrorMessage(this.$t('MSG0093'))
          return false
        }
      }

      if (this.setting.isValidateChecker) {
        if (this.existsUserInRoute()) {
          this.setErrorMessage(this.$t('MSG0094'))
          return false
        }

        const checker = this.getCurrentChecker()
        if (checker && checker.checkerCd != this.loginUserCd) {
          this.userConfirmDialog = true
          return false
        }
      }

      return true
    },
    getCurrentRoute() {
      // 現在の処理ルート取得
      return this.form.supplierRoute
    },
    getCmsCurrentRoute() {
      // 現在のcms処理ルート取得
      return this.form.cmsSupplierRoute
    },
    existsUserInRoute() {
      // 現在ルート詳細No以外で、ログインユーザーが指定されているかチェック
      return this.getCurrentRoute().checkers.some(
        (el) => el.routeDtlNo != this.form.currentRouteDtlNo && el.checkerCd == this.loginUserCd,
      )
    },
    getCurrentChecker() {
      // WFで指定されている現在の処理ユーザー取得
      return this.getCurrentRoute().checkers.find((el) => el.routeDtlNo == this.form.currentRouteDtlNo)
    },
    getCmsCurrentChecker() {
      // WFで指定されている現在のcms処理ユーザー取得
      return this.getCmsCurrentRoute()?.checkers.find((el) => el.routeDtlNo == this.form.currentRouteDtlNo)
    },
    async uploadAppFile() {
      // 外観検査の限度見本をS3へアップロード
      for (let idx = 0; idx < this.saApps.length; idx++) {
        if (!this.saApps[idx].filePath) {
          this.saApps[idx].filePath = await Storage.uploadFile(
            this.saApps[idx].file,
            'sa/' + this.form.saNo + '/' + S3Root.SA_APP,
          )
          this.saApps[idx].file = null
        }
      }
    },
    async uploadAttachFile() {
      // 添付ファイルをS3へアップロード
      for (let idx = 0; idx < this.attachFiles.length; idx++) {
        if (!this.attachFiles[idx].filePath) {
          this.attachFiles[idx].filePath = await Storage.uploadFile(
            this.attachFiles[idx].file,
            'sa/' + this.form.saNo + '/' + S3Root.SA_ATTACH,
          )
          this.attachFiles[idx].file = null
        }
      }
    },
    resetForm() {
      if (this.mode == SaveMode.TEMP_SAVE) {
        this.$emit('research', this.form.saNo)
      } else {
        this.$emit('reset')
      }
    },
    onChangeManufacturer() {
      // 製造会社が変更された際、製造会社を検索キーとするもののリセット
      this.form.partCd = ''
      this.form.saDims = []
      this.form.saApps = []
      for (const item of this.saLots) {
        item.inspIndexNo = ''
      }
    },
    cmsAttachmentFileExists() {
      return this.attachFiles.some((e) => e.fileCatCd == SaFileCatCd.CMS_SA)
    },
    canDeleteAttach(item) {
      let result = this.canEditAttach
      if (this.isCmsRoute) {
        result = this.canEditAttach && item.fileCatCd == SaFileCatCd.CMS_SA
      }
      return result
    },
    canDeleteLink(item) {
      let result = this.canEditLink
      if (this.isCmsRoute) {
        result = this.canEditLink && item.linkCatCd == SaLinkCatCd.CMS_SA
      }
      return result
    },
  },

  mounted() {
    this.setParameter()

    extend('saInspCharacVal', {
      validate: (value, { upper, lower }) => {
        let result = false
        if (value == '' || upper == '' || lower == '') {
          result = true
        } else {
          if (BigNumber(lower).gt(BigNumber(upper))) {
            result = this.$t('MSG0052')
          } else {
            result = true
          }
        }
        return result
      },
      params: ['upper', 'lower'],
    })

    extend('saExtendCharacUpperVal', {
      validate: (value, { charac, point }) => {
        let result = false
        if (this.isExtend) {
          if (value == '' || charac == '') {
            result = true
          } else {
            const findItem = this.relatedSaDims.find((e) => e.inspCharacCd == charac && e.inspCharacPoint == point)
            if (BigNumber(value).gt(BigNumber(findItem.saUpper))) {
              result = this.$t('MSG0131', { p0: findItem.saUpper })
            } else {
              result = true
            }
          }
        } else {
          result = true
        }
        return result
      },
      params: ['charac', 'point'],
    })
    extend('saExtendCharacLowerVal', {
      validate: (value, { charac, point }) => {
        let result = false
        if (this.isExtend) {
          if (value == '' || charac == '') {
            result = true
          } else {
            const findItem = this.relatedSaDims.find((e) => e.inspCharacCd == charac && e.inspCharacPoint == point)
            if (BigNumber(value).lt(BigNumber(findItem.saLower))) {
              result = this.$t('MSG0130', { p0: findItem.saLower })
            } else {
              result = true
            }
          }
        } else {
          result = true
        }
        return result
      },
      params: ['charac', 'point'],
    })

    this.inspClassTab = this.form.inspClassCd
  },
}
</script>

<style>
.form-sa-supplier .row > .col {
  padding: 6px;
}
.diff-text-field > .text-field-input > .v-input__control > .v-input__slot > fieldset {
  background: #fcf4a1;
}
</style>
